export default "__VITE_ASSET__BU2xiAR6__"